import { createSlice } from '@reduxjs/toolkit';

const planSlice = createSlice({
  name: 'plans',
  initialState: {
    isPlanCreated: false,
  },
  reducers: {
    setPlanCreated: (state, action) => {
      state.isPlanCreated = action.payload;
    },
    resetPlanCreated: (state) => {
      state.isPlanCreated = false;
    },
  },
});

export const { setPlanCreated, resetPlanCreated } = planSlice.actions;

export default planSlice.reducer;
